/// <reference types="react-froala-wysiwyg/lib" />
//Above line necessary due to crappy packaging by froala.
import React, { useEffect, useRef } from "react";
import FroalaEditorComponent from "react-froala-wysiwyg";
import "froala-editor/css/froala_style.min.css";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/plugins.pkgd.min.js";
import "froala-editor/js/languages/es.js";
import { useIntl } from "react-intl";
import { getLanguageFromFullLocale } from "../../../lib/config";

interface HtmlEditorProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  height?: number;
}

export function HtmlEditorWidget({ disabled, height, value, onChange }: HtmlEditorProps) {
  const intl = useIntl();
  const editorRef = useRef<FroalaEditorComponent>(null);
  const editor = editorRef.current?.getEditor().edit;

  useEffect(() => {
    if (editor) {
      if (disabled) editor.off();
      else editor.on();
    }
  }, [disabled, editor]);

  useEffect(() => {
    if (value && editorRef.current?.getEditor() && !editorRef.current.getEditor().loaded) {
      editorRef.current.getEditor()._original_html = value;
      editorRef.current.getEditor().loaded = true;
    }
  }, [value]);

  const toolbarButtons = {
    moreText: {
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikeThrough",
        "subscript",
        "superscript",
        "fontFamily",
        "fontSize",
        "textColor",
        "backgroundColor",
        "inlineClass",
        "inlineStyle",
        "clearFormatting",
      ],
    },
    moreParagraph: {
      buttons: [
        "alignLeft",
        "alignCenter",
        "formatOLSimple",
        "alignRight",
        "alignJustify",
        "formatOL",
        "formatUL",
        "paragraphFormat",
        "paragraphStyle",
        "lineHeight",
        "outdent",
        "indent",
        "quote",
      ],
    },
    moreRich: {
      buttons: [
        "insertLink",
        "insertImage",
        "insertTable",
        "emoticons",
        "fontAwesome",
        "specialCharacters",
        "embedly",
        "insertHR",
      ],
    },
    moreMisc: {
      buttons: ["undo", "redo", "fullscreen", "html", "help"],
      align: "right",
      buttonsVisible: 2,
    },
  };

  //TODO: move "key" to env var for packages
  return (
    <FroalaEditorComponent
      ref={editorRef}
      model={value}
      config={{
        toolbarSticky: false,
        height: height || 150,
        language: getLanguageFromFullLocale(intl.locale),
        pastePlain: true,
        key: "vYA6mC4C4C4G4B2B11dxE-11vusB2hiue1lknoioB9idaqD1G1F4A3B1C8E6D2C4A4==",
        attribution: false,
        toolbarButtons: toolbarButtons,
        charCounterCount: false,
      }}
      onModelChange={onChange}
    />
  );
}
